import { LoadingButton } from '@mui/lab'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from '@mui/material'

type RemoveCollaboratorDialogProps = DialogProps & {
  onClose: () => void
  onRemoveCollaborator: () => void
  isLoading: boolean
}

export function RemoveCollaboratorDialog({
  onRemoveCollaborator,
  isLoading,
  ...props
}: RemoveCollaboratorDialogProps) {
  return (
    <Dialog {...props}>
      <DialogTitle>Remover colaborador</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Tem certeza que deseja remover este colaborador?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={props.onClose}>
          Cancelar
        </Button>
        <LoadingButton
          loading={isLoading}
          onClick={onRemoveCollaborator}
          color="error"
        >
          Remover
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
